var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaDokument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{isolation:isolate;}.cls-3{mix-blend-mode:lighten;opacity:0.5;}.cls-4{fill:#eaa224;}.cls-5{fill:#fff;}.cls-6{fill:#b0b7bd;}.cls-7{fill:#eceef1;}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:#f2c136;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8,
    y: 28.2,
    width: 144,
    height: 119.63
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.88,39.35H12.27A4.27,4.27,0,0,0,8,43.62v95l.5,0,14.38-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.72,12.17A7.87,7.87,0,0,0,22.88,20V129.83a7.87,7.87,0,0,0,7.84,7.85h78.44a7.87,7.87,0,0,0,7.85-7.85V43.55L85.63,12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.48,43.55H117L85.63,12.17V35.7A7.87,7.87,0,0,0,93.48,43.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "117.01 67.08 93.47 43.55 117.01 43.55 117.01 67.08"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M122,144.88H11.86A3.86,3.86,0,0,1,8.13,140l25-68.6a3.84,3.84,0,0,1,3.72-2.85H147.05c2.54,0,3.71,2.41,3.71,4.85l-25,68.61a3.83,3.83,0,0,1-3.71,2.85Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaDokument);
export default __webpack_public_path__ + "static/media/ka_dokument.f62e1d03c605095eaa76ecb237235195.svg";
export { ForwardRef as ReactComponent };